var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.open != null)?_c('ExpansionPanels',{attrs:{"items":_vm.items,"open":_vm.open,"recommend":_vm.recommend,"showDescn":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }